<gc-loading-spinner [pixelSize]="32" />
